// ----------------------------------------------------------------------
/**
 * define if is ontouchstart or click event
 * @return  {string} clickmode - posible values: click, touch.
 */
const getClickMode = () => {
  let clickMode = 'click';
  const state = 'ontouchstart' in window;
  if (state) {
    $('body').addClass('is-touch').removeClass('is-no-touch');
    clickMode = 'touchstart';
  }
  return clickMode;
}


// ----------------------------------------------------------------------
/**
 * Muestra/Oculta el menú de bancanet
 * @param   {string} clickMode - Nombre del evento click|touchstart
 * @return  {void}
*/
const bancanetActions = (clickMode) => {
  $('.dropdown').find('.dropdown-toggle').on(clickMode, function () {
    var $dropdown = $(this).parent('.dropdown');
    $dropdown.toggleClass('is-active-menu')
  })
}


// ----------------------------------------------------------------------
/**
 * Define las acciones del menú principal y submenus
 * @param {string} clickMode - Nombre del evento click|touchstart
 */
const menuActions = (clickMode) => {

  let _clickMode;

  /**
   * Define acciones para el botón del menú mobile
   * @return  {void}
   */
  const btnMobileActions = () => {
    $('.btn-responsive-menu').on(_clickMode, function (e) {
      e.preventDefault();
      var $btn = $(this);
      $btn.toggleClass('is-active');
      $('.main-menu').toggleClass('is-active');
    })
  }

  /**
   * Define acciones para mostrar/ocultar los submenus en dispositivos móbiles y touch
   * @return  {void}
   */
  const mobileMenu = () => {
    $('.main-menu').find('.primary > a').on(_clickMode, function (e) {
      var isTouch = $('body').hasClass('is-touch');
      var Ww = $(window).width();
      if (isTouch || Ww < 992) {
        e.preventDefault();
        var $parent = $(this).parent('.primary');

        var haveSubmenu = $parent.find('.sub-menu').length >= 1 ? true : false;
        if (haveSubmenu) {

          // hide otther sub-menus
          $('.main-menu').find('.primary.is-active').not($parent).removeClass('is-active');

          // toggle current submenu
          $parent.toggleClass('is-active');
        }
      }
    })
  }

  /**
   * Inicializa las acciones de los menús
   * @param   {string} clickMode - Nombre del evento click|touchstart
   */
  const constructor = ((clickMode) => {
    _clickMode = clickMode;
    mobileMenu();
    btnMobileActions();
  })(clickMode);
}


// ----------------------------------------------------------------------
/**
 * 
 * @param {string} clickMode - Nombre del evento click|touchstart
 */
const searchActions = (clickMode) => {
  $('.btn-seach').on(clickMode, function (e) {
    e.preventDefault();
    var $btn = $(this);
    $btn.toggleClass('is-active');
  })
}


// ----------------------------------------------------------------------
/**
 * Definición del document ready de jquery
 * @return  {void}
 */
$(document).ready(function () {
  const clickMode = getClickMode();
  bancanetActions(clickMode);
  menuActions(clickMode);
  searchActions(clickMode);
})